var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfluencerProfile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#24221E;}\n\t.st1{fill:#FFE3D4;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFB18F;}\n\t.st4{fill:#F57171;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_13050",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13047-2",
    transform: "translate(0.714 0.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10783",
    className: "st0",
    d: "M14.7,48.9c7.5,2.9,15.6,4.1,23.7,3.5c6.1-0.6,13.5-3.4,16.6-8.8c6.5-11.3-1-25.9-12.7-29.9 c-6.6-2.2-14.3-0.8-20.2,2.9c-6.8,4.3-9.3,10.8-9.9,18.5c-0.3,3.6-1.6,7.6-5,9.3C9.3,46.5,11.9,48,14.7,48.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10784",
    className: "st0",
    d: "M15.2,50.3c5.2,2,10.6,3.2,16.1,3.6c4.9,0.5,9.8,0,14.5-1.5c4.1-1.4,8.1-3.8,10.4-7.6 c2-3.5,2.9-7.5,2.5-11.6c-0.4-4-1.9-7.8-4.2-11c-2.3-3.3-5.5-5.9-9.1-7.7c-4.5-2-9.5-2.5-14.2-1.4c-4.8,0.9-9.1,3.3-12.6,6.6 c-2.9,3-4.8,6.9-5.6,11c-0.2,1.1-0.4,2.2-0.5,3.3c-0.1,0.6-0.1,1.1-0.2,1.7c0,0.5-0.1,1-0.2,1.4c-0.2,1-0.4,2.1-0.8,3.1 c-0.2,0.4-0.4,0.9-0.6,1.3c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.3,0.4-0.4,0.6c-0.6,0.8-1.4,1.4-2.3,1.8c-0.3,0.2-0.5,0.7-0.2,1 c0,0,0.1,0.1,0.1,0.1C9.6,47.8,12.3,49.4,15.2,50.3c0.4,0.1,0.8-0.1,0.9-0.5c0.1-0.4-0.1-0.8-0.5-0.9c-2.7-0.9-5.2-2.3-7.2-4.3 l-0.1,1.1c1.9-1,3.4-2.6,4.1-4.6c0.4-1,0.7-2,0.9-3.1c0.2-1.1,0.3-2.1,0.4-3.2c0.1-1.1,0.2-2,0.4-3.1c0.2-1,0.4-2,0.7-3 c0.6-1.9,1.4-3.7,2.5-5.3c0.5-0.8,1.1-1.6,1.8-2.3c0.7-0.8,1.5-1.5,2.3-2.1c0.9-0.7,1.8-1.3,2.8-1.8c1-0.6,2.1-1.1,3.2-1.5 c4.5-1.8,9.4-2.1,14.1-1c0.5,0.1,1.1,0.3,1.6,0.5c0.2,0.1,0.4,0.2,0.6,0.2l0.2,0.1l0.1,0l0.1,0l0.2,0.1c0.9,0.4,1.7,0.8,2.6,1.4 c0.8,0.5,1.5,1,2.3,1.6c0.7,0.6,1.5,1.3,2.1,2c2.6,2.8,4.5,6.1,5.4,9.8c0.1,0.5,0.2,0.9,0.3,1.4c0,0.2,0.1,0.4,0.1,0.7 c0,0,0,0.2,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0.1,0.9,0.1,1.9,0.1,2.8c0,0.5-0.1,1-0.1,1.4c0,0.1,0,0.1,0,0.2 c0-0.1,0,0,0,0c0,0.1,0,0.2-0.1,0.4c0,0.3-0.1,0.5-0.1,0.8c-0.2,0.9-0.5,1.9-0.8,2.8c-0.4,0.9-0.8,1.8-1.3,2.6 c-0.5,0.8-1.1,1.6-1.8,2.3c-1.5,1.5-3.2,2.6-5.1,3.5c-0.9,0.5-1.9,0.8-2.9,1.2c-1,0.3-2,0.6-3.1,0.8c-1,0.2-1.9,0.4-2.9,0.4 c-1.3,0.1-2.7,0.2-4,0.2c-5.4,0-10.7-0.8-15.9-2.4c-1.2-0.4-2.4-0.8-3.6-1.2c-0.4-0.1-0.8,0.1-0.9,0.5 C14.6,49.8,14.8,50.2,15.2,50.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13059",
    transform: "translate(0.87 1.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13054",
    transform: "translate(7.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13051",
    transform: "translate(0.725 0.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10785",
    className: "st0",
    d: "M15,26.4c5-1.6,9.8-4,14-7.2c3.2,3.4,7,6,11.3,7.9c1,0.5,2.1,0.8,3.2,0.9 c1,0.1,2.1-0.1,3-0.5c0,0-0.1,0-0.1,0c-3-10.9-14.3-17.2-25.2-14.2c-6.7,1.9-11.9,7-14,13.6C9.7,27.8,12.5,27.2,15,26.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    className: "st0",
    d: "M15.9,27.8c4-1.2,7.8-3,11.3-5.3c1-0.6,1.9-1.3,2.9-2l-0.9-0.1c1.8,1.9,3.9,3.7,6.1,5.1 c1.1,0.7,2.2,1.4,3.4,2c1.2,0.7,2.5,1.2,3.8,1.6c1.6,0.5,3.3,0.4,4.9-0.2c0.4-0.1,0.6-0.5,0.5-0.9c-0.1-0.4-0.5-0.6-0.9-0.5 l-0.1,0l0.9,0.5c-3.2-11.2-14.8-17.8-26.1-14.7C15.2,15.3,10,20,7.6,26.3c-0.2,0.4-0.3,0.8-0.4,1.2c-0.1,0.4,0.1,0.8,0.5,0.9 C10.4,29.2,13.3,28.6,15.9,27.8c0.4-0.1,0.6-0.5,0.5-0.9c-0.1-0.4-0.5-0.6-0.9-0.5c-2.4,0.7-5,1.3-7.5,0.6l0.5,0.9 c1-3.1,2.7-6,5.1-8.3c4.9-4.7,11.9-6.6,18.5-5c1.6,0.4,3.1,1,4.6,1.8c0.7,0.4,1.4,0.8,2.1,1.3c0.6,0.5,1.2,1,1.8,1.5 c0.6,0.6,1.2,1.1,1.7,1.8c0.5,0.6,1,1.2,1.4,1.9c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.7,1.4,0.9,2.2c0.1,0.4,0.3,0.8,0.4,1.2 c0.1,0.4,0.5,0.6,0.9,0.5l0.1,0L47,27.6c-1.2,0.5-2.5,0.6-3.8,0.3c-1.2-0.4-2.4-0.9-3.6-1.5c-2.2-1.1-4.3-2.5-6.2-4.1 c-1.1-0.9-2.1-1.9-3.1-2.9c-0.2-0.2-0.6-0.3-0.9-0.1c-3.2,2.5-6.8,4.5-10.5,6c-1.1,0.4-2.2,0.8-3.3,1.2 c-0.4,0.1-0.6,0.5-0.5,0.9C15.1,27.7,15.5,27.9,15.9,27.8C15.9,27.8,15.9,27.8,15.9,27.8L15.9,27.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13058",
    transform: "translate(0 6.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13055",
    transform: "translate(0.718 0.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    className: "st1",
    d: "M55.5,20.6c-0.6,0-1.3,0.1-1.9,0.4c-1,0.4-2,0.6-3,0.5c-1.1-0.1-2.2-0.4-3.2-0.9 c-4.2-1.9-8.1-4.6-11.3-7.9c-4.2,3.2-8.9,5.6-14,7.2c-2.5,0.8-5.3,1.3-7.8,0.6c-0.1,0.2-0.1,0.4-0.2,0.6c-2.5-1.1-5.5,0-6.6,2.6 c-1.1,2.5,0,5.5,2.6,6.6c1.2,0.5,2.5,0.6,3.7,0.2c2.1,11.1,12.8,18.3,23.9,16.2c8.2-1.6,14.6-8,16.2-16.2 c2.6,0.9,5.5-0.6,6.3-3.2s-0.6-5.5-3.2-6.3C56.6,20.7,56,20.6,55.5,20.6L55.5,20.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    className: "st0",
    d: "M56.2,20.6c-0.8,0-1.5,0.2-2.2,0.5c-0.6,0.3-1.3,0.4-2,0.4c-1.4-0.1-2.8-0.5-4.1-1.1 c-2.5-1.1-4.8-2.6-7-4.3c-1.2-1-2.4-2.1-3.5-3.2c-0.2-0.2-0.6-0.3-0.9-0.1c-2.4,1.8-5,3.4-7.7,4.7c-1.3,0.6-2.7,1.2-4.1,1.7 c-1.4,0.5-2.9,1-4.4,1.3c-1.7,0.4-3.4,0.4-5-0.1c-0.4-0.1-0.8,0.1-0.9,0.5c-0.1,0.2-0.1,0.4-0.2,0.6l1.1-0.4 c-1.5-0.7-3.2-0.7-4.7,0c-1.2,0.5-2.2,1.5-2.8,2.7c-1.4,2.8-0.2,6.3,2.6,7.7c1.4,0.7,2.9,0.8,4.3,0.3l-0.9-0.5 C16.1,42.8,27.2,50.3,38.6,48C46.6,46.5,53,40.5,55,32.7c0.1-0.5,0.2-0.9,0.3-1.4l-0.9,0.5c3,1,6.3-0.7,7.2-3.7 c1-3-0.7-6.3-3.7-7.2C57.4,20.7,56.8,20.6,56.2,20.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0.1,0,0.3,0,0.4,0 c0.1,0,0.1,0,0.2,0c-0.1,0,0.1,0,0.1,0c0.3,0,0.5,0.1,0.8,0.2l0.1,0.1c0.2,0.1-0.1-0.1,0.1,0c0.1,0.1,0.2,0.1,0.3,0.2 s0.2,0.1,0.3,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0.2,0.2,0.1,0.1c0.4,0.3,0.7,0.6,0.9,1c0.3,0.4,0.5,0.8,0.6,1.3 c0.1,0.5,0.2,1,0.1,1.5c0,0.1,0,0.1,0,0.2c0,0.1,0-0.2,0,0.1c0,0.1,0,0.2-0.1,0.4s-0.1,0.2-0.1,0.4c0,0.1,0,0.1-0.1,0.2 c0,0-0.1,0.2,0,0.1c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1,0.1-0.1,0,0.1c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.4-1.5,0.5c0,0,0.1,0,0,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0 c-0.4,0-0.8-0.1-1.1-0.2c-0.4-0.1-0.8,0.1-0.9,0.5c-0.3,1.8-0.9,3.5-1.7,5.1c-0.4,0.8-0.8,1.6-1.3,2.3c-0.5,0.7-1,1.4-1.6,2 c-1.2,1.3-2.5,2.4-3.9,3.4c-0.7,0.5-1.5,0.9-2.3,1.3c-0.8,0.4-1.6,0.7-2.4,1c-0.9,0.3-1.8,0.5-2.7,0.7 c-0.5,0.1-0.8,0.1-1.3,0.2S35.8,47,35.3,47c-1.9,0.1-3.7-0.1-5.5-0.6c-3.4-0.9-6.6-2.6-9.1-5.1c-2.5-2.5-4.3-5.6-5.2-9 c-0.1-0.4-0.2-0.9-0.3-1.3c-0.1-0.4-0.5-0.6-0.9-0.5c-0.7,0.2-1.4,0.3-2,0.2c0.1,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1,0.1,0.1-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-0.5-0.2-0.9-0.5-1.2-0.9 c-0.2-0.2-0.3-0.3-0.4-0.5c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.2,0-0.1c-0.1-0.3-0.2-0.6-0.3-0.8 c0,0,0-0.1,0-0.1c0,0,0-0.2,0-0.1c0-0.2,0-0.4,0-0.5c0-0.5,0.1-1.1,0.3-1.6c0.2-0.4,0.4-0.9,0.7-1.2c0.3-0.4,0.7-0.7,1.2-1 c0.1-0.1,0.3-0.2,0.4-0.2c0.2-0.1-0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.2,0 c0,0,0.2,0,0.1,0c0.8-0.1,1.5,0,2.3,0.3c0.4,0.2,0.8,0.1,1-0.3c0,0,0-0.1,0.1-0.1c0.1-0.2,0.1-0.4,0.2-0.6l-0.9,0.5 c3.2,0.9,6.6,0,9.6-1c2.9-1,5.8-2.3,8.5-3.9c1.5-0.9,2.9-1.9,4.3-2.9l-0.9-0.1c2,2.1,4.2,3.9,6.7,5.5c1.2,0.8,2.5,1.5,3.7,2.1 c1.4,0.8,2.9,1.3,4.4,1.5c0.9,0.1,1.8,0,2.6-0.3c0.4-0.1,0.8-0.3,1.2-0.4c0.4-0.1,0.8-0.2,1.1-0.2c0.4,0,0.7-0.3,0.7-0.7 S56.6,20.6,56.2,20.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13062",
    transform: "translate(20.601 18.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13060"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1275",
    className: "st0",
    cx: 8.5,
    cy: 14,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13061",
    transform: "translate(12.73)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1276",
    className: "st0",
    cx: 8.5,
    cy: 14,
    rx: 1.3,
    ry: 1.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13064",
    transform: "translate(26.313 19.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    className: "st0",
    d: "M8.2,14.3C8.4,14.3,8.1,14.4,8.2,14.3L8.2,14.3c0.2-0.1,0.3-0.1,0.3-0.1 c0.1,0,0.3-0.1,0.4-0.1l-0.2,0c0.2,0,0.5,0,0.7,0l-0.2,0c0.1,0,0.3,0.1,0.4,0.1l0.1,0c0.1,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.1 c0.3,0.2,0.8,0.1,1-0.2s0.1-0.8-0.2-1c0,0,0,0,0,0c-0.5-0.3-1-0.4-1.6-0.4c-0.6,0-1.2,0.2-1.7,0.4c-0.2,0.1-0.3,0.2-0.3,0.4 c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.3C7.9,14.4,8.1,14.4,8.2,14.3L8.2,14.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13068",
    transform: "translate(22.963 22.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13065",
    transform: "translate(0.712 0.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    className: "st2",
    d: "M7.3,13.9c2.8,4.3,6.3,4.2,9.2,0.1c0.3-0.4,0.2-0.9-0.2-1.1c-0.1-0.1-0.3-0.1-0.5-0.1 l-7.8,0c-0.4,0-0.8,0.3-0.8,0.8C7.2,13.6,7.2,13.8,7.3,13.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    className: "st0",
    d: "M7.4,15c1.2,1.9,3.2,3.8,5.6,3.5c1.1-0.2,2.2-0.7,3-1.4c0.5-0.4,0.9-0.9,1.3-1.3 c0.5-0.5,0.8-1.2,0.7-1.9c-0.2-0.6-0.8-1.1-1.5-1.1c-0.1,0-0.2,0-0.2,0l-1.5,0l-4.4,0c-0.5,0-1,0-1.5,0c-0.3,0-0.7,0.1-0.9,0.3 C7.2,13.4,7,14.3,7.4,15c0.2,0.3,0.7,0.4,1,0.2c0.3-0.2,0.4-0.6,0.2-1c-0.1-0.2,0,0.1,0,0c0-0.1,0,0.1,0,0s0,0,0,0l0-0.1 c0,0.1,0,0.1,0,0l0,0c0-0.1,0-0.1,0,0l0,0l0,0l0.1,0c-0.1,0-0.1,0,0,0c0.1,0-0.2,0,0,0h0.2l1.3,0l4,0c0.8,0,1.6,0,2.4,0 c0,0,0,0,0.1,0c-0.1,0,0,0,0,0l-0.1,0c0.1,0,0.1,0,0,0c-0.1,0,0.1,0.1,0,0c0,0,0,0.1,0.1,0.1c-0.1-0.2,0,0,0,0l0-0.1 c0,0.1,0,0.1,0,0c0,0-0.1,0.2,0,0.1c-0.3,0.5-0.6,0.9-1,1.3c-0.3,0.3-0.7,0.7-1.1,0.9c-0.2,0.1-0.4,0.2-0.6,0.3l-0.1,0.1 c0.1-0.1,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1S13.2,17,13.1,17c-0.1,0-0.1,0-0.2,0l0,0l-0.1,0c-0.2,0-0.4,0-0.7,0c-0.1,0,0.2,0,0,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2-0.1c0,0-0.2-0.1-0.1,0c-0.1,0-0.2-0.1-0.3-0.1 c-1-0.6-1.8-1.4-2.4-2.4c-0.2-0.3-0.6-0.5-1-0.3C7.3,14.2,7.2,14.7,7.4,15z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13071",
    transform: "translate(10.663 21.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13069"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1277",
    className: "st3",
    cx: 11.4,
    cy: 16.9,
    rx: 4.2,
    ry: 4.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13070",
    transform: "translate(26.801)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1278",
    className: "st3",
    cx: 11.4,
    cy: 16.9,
    rx: 4.2,
    ry: 4.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13072",
    transform: "translate(36.596 0.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    className: "st4",
    d: "M17.5,13.4c-1.5-0.1-2.8,0.8-3.3,2.2c-0.4-1.4-1.8-2.3-3.3-2.2c-1.8,0.1-3.2,1.7-3.1,3.5 c0.2,4.1,4.1,6.3,5.7,7c0.4,0.2,0.9,0.2,1.3,0c1.6-0.7,5.5-2.9,5.7-7C20.7,15.1,19.3,13.5,17.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    className: "st0",
    d: "M14.2,24.7c-0.3,0-0.6-0.1-0.9-0.2c-1.8-0.8-5.9-3.1-6.1-7.6c-0.1-2.2,1.5-4.1,3.7-4.2 c1.3-0.1,2.5,0.5,3.3,1.5c0.8-1,2-1.5,3.3-1.5l0,0c2.2,0.1,3.9,2,3.7,4.2c-0.2,4.5-4.3,6.8-6.1,7.6C14.9,24.6,14.5,24.7,14.2,24.7 z M11.1,14.1c0,0-0.1,0-0.1,0c-1.4,0.1-2.5,1.3-2.4,2.7c0.2,3.7,3.7,5.7,5.3,6.3c0.2,0.1,0.5,0.1,0.7,0c1.5-0.7,5.1-2.7,5.3-6.3 c0.1-1.4-1-2.6-2.4-2.7l0,0c-1.1-0.1-2.2,0.6-2.6,1.7c-0.1,0.3-0.4,0.5-0.7,0.5l0,0c-0.3,0-0.6-0.2-0.7-0.5 C13.2,14.8,12.2,14.1,11.1,14.1L11.1,14.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13073",
    transform: "translate(3.164 10.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    className: "st4",
    d: "M16.1,13.4c-1.3-0.1-2.4,0.7-2.8,1.9c-0.4-1.2-1.5-2-2.8-1.9c-1.5,0.1-2.7,1.4-2.6,3 c0.2,3.5,3.5,5.4,4.9,6c0.4,0.2,0.8,0.2,1.1,0c1.4-0.6,4.7-2.5,4.9-6C18.8,14.8,17.7,13.5,16.1,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    className: "st0",
    d: "M13.3,23.2c-0.3,0-0.6-0.1-0.9-0.2c-1.5-0.7-5.1-2.7-5.3-6.6c-0.1-1.9,1.4-3.6,3.3-3.7 c1.1-0.1,2.1,0.4,2.9,1.2c0.7-0.8,1.8-1.2,2.8-1.2l0,0c1.9,0.1,3.4,1.8,3.3,3.7c-0.2,3.9-3.8,5.9-5.3,6.6 C13.9,23.1,13.6,23.2,13.3,23.2z M10.7,14.1h-0.1c-1.1,0.1-2,1.1-1.9,2.2c0.1,3.1,3.2,4.8,4.5,5.4c0.2,0.1,0.4,0.1,0.5,0 c1.3-0.6,4.3-2.3,4.5-5.4c0.1-1.1-0.8-2.1-1.9-2.2c-0.9-0.1-1.8,0.5-2.1,1.4c-0.1,0.3-0.4,0.5-0.7,0.5l0,0c-0.3,0-0.6-0.2-0.7-0.5 C12.4,14.7,11.6,14.1,10.7,14.1L10.7,14.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13074",
    transform: "translate(33.177 34.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10796",
    className: "st4",
    d: "M15.6,13.4c-1.2-0.1-2.3,0.7-2.6,1.8c-0.4-1.1-1.4-1.9-2.6-1.8c-1.4,0.1-2.5,1.3-2.5,2.8 c0.2,3.3,3.3,5,4.6,5.6c0.3,0.1,0.7,0.1,1,0c1.3-0.6,4.4-2.3,4.6-5.6C18.2,14.7,17.1,13.5,15.6,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    className: "st0",
    d: "M13,22.6c-0.3,0-0.6-0.1-0.8-0.2c-1.4-0.7-4.8-2.6-5-6.2c-0.1-1.8,1.3-3.4,3.1-3.5 c1-0.1,2,0.3,2.7,1.1c0.7-0.7,1.7-1.1,2.7-1.1l0,0c1.8,0.1,3.2,1.7,3.1,3.5c-0.2,3.7-3.6,5.6-5,6.2C13.5,22.6,13.3,22.6,13,22.6z  M10.5,14.1h-0.1c-1,0.1-1.8,1-1.8,2c0.1,2.9,2.9,4.4,4.1,5c0.1,0.1,0.3,0.1,0.4,0c1.2-0.5,4-2.1,4.2-5c0.1-1.1-0.7-2-1.8-2l0,0 c-0.9-0.1-1.6,0.5-1.9,1.3c-0.1,0.3-0.4,0.5-0.7,0.5l0,0c-0.3,0-0.6-0.2-0.7-0.5C12,14.6,11.3,14.1,10.5,14.1L10.5,14.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencerProfile01);
export default __webpack_public_path__ + "static/media/influencer_profile01.767e87de199bb020236b3267c38f5cc7.svg";
export { ForwardRef as ReactComponent };